<template>
  <div class="index">
      <top-nav></top-nav>
      <ul id="fullMenu">
          <li data-menuanchor="firstPage" @click="gotolastpage('firstPage')"><i v-show="sectionIndex == 0"></i></li>
          <li data-menuanchor="secondPage" @click="gotolastpage('secondPage')"><i v-show="sectionIndex == 1"></i></li>
          <li data-menuanchor="thirdPage" @click="gotolastpage('thirdPage')"><i v-show="sectionIndex == 2"></i></li>
      </ul>

      <full-page ref="fullpage" :options="options" id="fullpage">
        <div class="section banner" ref="section1">
          <Carousel  v-model="carouseIndex" loop arrow="never" autoplay :autoplay-speed="5000">
            <CarouselItem :style="carouseHeight">
              <img src="../../../static/images/play.png" class="playBtn" @click="play1()" >
              <div class="indexVideoBg">  </div>
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_03.jpg')"> </div>
            </CarouselItem>
            <CarouselItem :style="carouseHeight">
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_06.jpg');cursor: pointer;" @click="toNewsDetail(444)"></div>
            </CarouselItem>
            <CarouselItem :style="carouseHeight">
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_04.jpg?011801');cursor: pointer;" @click="toNewsDetail(363)"></div>
            </CarouselItem>
            <CarouselItem :style="carouseHeight">
              <img src="../../../static/images/play.png" class="playBtn" @click="play()" >
              <div class="indexVideoBg">  </div>
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_02.jpg')"></div>
            </CarouselItem>
            <CarouselItem :style="carouseHeight">
              <img src="../../../static/images/play.png" class="playBtn" @click="play()" >
              <div class="indexVideoBg">  </div>
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_01.jpg?0219')"></div>
            </CarouselItem>
            <CarouselItem :style="carouseHeight">
              <img src="../../../static/images/play.png" class="playBtn" @click="play1()" >
              <div class="indexVideoBg">  </div>
              <div class="demo-carousel" style="backgroundImage:url('../../../static/images/banner_05.jpg')"></div>
            </CarouselItem>
          </Carousel>

          
        </div>
        <div class="section">
          <div class="home-module">
            <div class="home-title">企业动态</div>              
            <div class="home-dynamic">
              <ul class="news-wrapper">                  
                <li class="news-item" v-for="(news,index) in newsArr" :key="'news'+index" @mouseenter="news.showMask = true" @mouseleave="news.showMask = false" @click="toNewsDetail(news.id)">
                  <a>
                    <transition name="slide-fade">
                      <div class="mask" v-show="news.showMask"><Icon type="ios-link-outline" /></div>
                    </transition>
                    <div class="news-item-img"><img :src="news.summaryImg" alt=""></div>
                    <div class="news-item-title">{{news.title}}</div>
                  </a>
                </li> 
                <li class="news-item" @click="toNews()">
                  <a class="news-item-more">
                      更多>>
                  </a>
                </li>                   
              </ul> 
            </div>
          </div>
          
        </div>
        <div class="section">
          <div class="home-module">
            <div class="home-title2">解决方案</div> 
            <ul class="home-solution clearfix">
              <li v-for="(item,index) in solutionArr" :key="'solution'+index" class="solution-item" @mouseenter="item.showMask = true" @mouseleave="item.showMask = false" @click="toDetail(item.url)">
                <transition name="slide-fade">
                  <div class="solution-info"  v-show="item.showMask">
                    <p class="solution-title">{{item.title}}</p>
                    <div class="solution-profile">{{item.content}}</div>
                  </div>
                </transition>
                <img :src="item.img" alt="" srcset="">
              </li>
              <li class="solution-item" @click="toCase()">
                <img src="../../../static/images/solutionPic.jpg">
              </li>
            </ul>  
          </div>    

          <bottom-footer></bottom-footer>
        </div>
      </full-page>

      <div class="modalBg" ref = "temp1" style="display:none;">
        <div class="modalWarp">
          <video ref="video1" src="static/video/reyzarVideo.mp4" controls></video>
          <div class="closeBg" @click="close()"><img src="../../../static/images/closeBg.png"></div>
        </div>
      </div>
  </div>
</template>

<script>
import topNav from '@/components/topNav'
import bottomFooter from '@/components/bottomFooter.vue'
export default {
  name: 'index',
  data () {
    return {
      showMask:false,
      carouseHeight: {height:'500px',position:'relative'},
      carouseIndex:0,
      sectionIndex: 0,
      options: {
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        afterLoad: this.afterLoad,
        onLeave:this.onLeave,
        anchors: ['firstPage', 'secondPage', 'thirdPage'],
        lockAnchors: true,
        slidesNavigation: true,
        sectionsColor: ['#fff','#313236','#fff'],
        menu: '#fullMenu',
        verticalCentered: true,
      },
      solutionArr:[
        {
          title: '智慧政务',
          content: '智慧政务作为政府的对外服务窗口，方便互联网用户了解政府最新资讯，以及办理各项业务，提升政府服务效率，而互联网用户归类包括IPv4和IPv6用户，所以需要实现对IPv6用户的同步覆盖。',
          img: '../../../static/images/solutionPic2.jpg',
          url:'/solutionCase1',
          showMask: false,
        },
        {
          title: '平安城市',
          content: '利用IPv6海量地址的特征实现全网安全监控摄像头统一编址，解决多个监控网络无法互通的问题，实现在原有IPv4监控平台访问、管理、存储IPv6摄像头及视频的功能。',
          img: '../../../static/images/solutionPic3.jpg',
          url:'/solutionCase2',
          showMask: false,
        },
        {
          title: '智慧教育',
          content: '提供教学、科研和综合信息服务的宽带多媒体网络，跟踪和使用最新的IPv6的应用和技术，便于科研探索，辅助培育IPv6的技术型人才。',
          img: '../../../static/images/solutionPic5.jpg',
          url:'/solutionCase3',
          showMask: false,
        },
        {
          title: '无线城市',
          content: '使用无线宽带技术实现城市热点区域的无线通信覆盖，向公众提供随时随地接入和高速度的无线网络，充分发挥IPv6即接即用的特性。',
          img: '../../../static/images/solutionPic1.jpg',
          url:'/solutionCase4',
          showMask: false,
        },
        {
          title: '智慧医疗',
          content: '通过区域综合信息平台的互联互通、资源共享，实现公共卫生、医疗服务和卫生管理的一体化。解决不同医院之间的医疗资料系统无法互通的问题。',
          img: '../../../static/images/solutionPic4.jpg',
          url:'/solutionCase5',
          showMask: false,
        },
      ],
      newsArr:[],
      videoUrl: '',
      
    }
  },

  components: {
    topNav,
    bottomFooter,
  },



  computed: {
      
  },

  mounted(){
    this.carouseHeight.height = this.$refs.section1.style.height;
    this.getNewsData();
    this.videoUrl=this.$refs.video1.baseURI.replace('/#','')
  },

  methods: {
    toCase(){
      this.$router.push({path: '/case'})
    },
    play()
    { 
      this.$refs.temp1.style.display = 'block'
      this.$refs.video1.src = "http://www.reyzar.com/images/upload/video/reyzarVideo.mp4";
      // this.$refs.video1.src = this.videoUrl+"static/video/reyzarVideo.mp4";
      this.$refs.video1.play();
    },
    play1()
    { 
      this.$refs.temp1.style.display = 'block'
      this.$refs.video1.src = 'http://www.reyzar.com/images/upload/video/reyzar.mp4';
      // this.$refs.video1.src = this.videoUrl+"static/video/reyzar.mp4";
      this.$refs.video1.play();
    },
    close(){
      this.$refs.video1.load();

      this.$refs.temp1.style.display = 'none'
    },

    toNewsDetail(id){
      this.$router.push({path:'/newsDetail',query:{id:id}})
    },

    toNews(){
      this.$router.push({path:'/news'})
    },
    toDetail(url){
      this.$router.push({path:url})
    },
    getNewsData(){
      let params = {
        page: 1,
        pageSize: 7
      }
      this.$axios.get('api/gw/findAllRzNews',{params}).then((data)=>{
        data.data.data.list.map(item=>{
          item.showMask = false
        })
        this.newsArr = data.data.data.list;
      }).catch((err)=>{
        console.log(err);
      })
    },
    gotolastpage(page){
      fullpage_api.moveTo(page, 1);
    },
    afterLoad(origin, destination, direction) {
      
    },
    onLeave (index, nextIndex, direction){
      this.sectionIndex = nextIndex.index
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
.index{
  .bannerVideoBtn{ width:auto; line-height:1.14rem; font-size:1.14rem; color:#fff; text-align:center; position:absolute; left:50%; bottom:2rem; transform:translateX(-50%);}
    .indexVideoBg{ width:100%; height:100%; background:#000; position:fixed; top:0; left:0; z-index:998; display:none;}
    .indexVideoBg video{ width:100%; position:absolute; top:50%; left:0; transform:translateY(-50%);}
    /*视频*/
    .playVideoBg{ width:100%; height:256px; position:absolute; background-color:rgba(0,0,0,0.1); top:0; left:0;}
    .playVideoBg img{ width:120px; position:absolute; top:50%; left:50%; margin-left:-60px; margin-top:-60px; opacity:0.8; cursor:pointer;}
    .playVideoBg img:hover{ opacity:1;}
    .modalBg{ width:100%; height:100%; background-color:rgba(0,0,0,0.5); position:fixed; top:0; left:0; display:none; z-index:999;}
    .modalWarp{ width:50%; max-width:1000px; height:auto; position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);}
    .modalBg video{ width:100%;}
    .closeBg{ width:30px; height:30px; position:absolute; top:-40px; right:0; cursor:pointer;}
    .closeBg img{ width:100%;}

    /*首页视频*/
    .indexVideoBg{ width:100%; height:100%; background-color:rgba(0,0,0,0.1); position:absolute; top:0; left:0; display:none; z-index:2;}
    .banner li:hover .indexVideoBg{ display:inherit;}
    .playBtn{ width:120px; height:120px; bottom:10%; left:50%; margin-left:-60px; position:absolute; cursor:pointer;}
    .banner ul li .slide_bg{ position:relative;}
 
  
  .section{
    position: relative;
    .bottomFooter{
      position: absolute;
      left: 0;
      bottom: 50px;
    }
  }
  
  .ivu-carousel-dots li{
    margin: 0 30px;
  }
  .ivu-carousel-dots li button{
    width: 60px;
  }
  .ivu-carousel-dots li.ivu-carousel-active>button{
    width: 80px;
  }
  .demo-carousel{
    height: 100%;
    width: 100%;
    background-position: center;
    background-size: cover;
  }
  
  #fullMenu{
    width: 16px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 20px;
    margin-top: -50px;
    z-index: 3;
    li{
      width: 16px;
      height: 16px;
      border: 1px solid $color;
      border-radius: 50%;
      position: relative;
      margin-bottom: 26px;
      cursor: pointer;
      i{
        width: 10px;
        height: 10px;
        margin: 3px;
        background-color: #73a9f1;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -5px;
        margin-left: -5px;
      }
    }
  }
  .home-module{
    width: 1200px;
    margin: auto;
    .home-title{
      width: 100%;
      line-height: 50px;
      font-size: 30px;
      color: #fff;
      text-align: center;
      padding: 10% 0 3%;
    }
    .home-title2{
      width: 100%;
      line-height: 30px;
      font-size: 30px;
      color: #818181;
      text-align: center;
      padding: 30px 0;
    }
  }
  .home-solution{
    
    .solution-item{
      width: 400px;
      height: 250px;
      line-height: 250px;
      text-align: center;
      font-size: 30px;
      color: #fff;
      float: left;
      overflow: hidden;
      background-color: #313133;
      position: relative;
      cursor: pointer;
      .solution-info{
        width: 100%;
        height: 250px;
        background-color: rgba(115, 169, 241, 0.8);
        position: absolute;
        top: 0;
        left: 0;
        padding: 40px;
        .solution-title{
          width: 100%;
          line-height: 24px;
          font-size: 24px;
          color: #fff;
          padding-bottom: 15px;
          text-align: left;
        }
        .solution-profile{
          width: 100%;
          line-height: 28px;
          font-size: 15px;
          color: #fff;
          text-align: justify;
        }
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .news-wrapper {
    width: 100%;
    .news-item{
      float: left;
      width: 288px;
      height: 194px;
      margin: 5px 6px;
      list-style-type: none;
      position: relative;    
       
      .mask{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        background: rgba(0,0,0,0.25);
        text-align: center;
        i{
          color: #fff;
          line-height: 194px;
          font-size: 30px;
        }
      }
      .news-item-img{
        width: 288px;
        height: 194px;
        position: relative;
        background-position: bottom center;
        background-size: cover;
        background-repeat: no-repeat;
        img{
          width: 288px;
          height: 194px;
        }
      }
      .news-item-title{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        background-color: rgba(0,0,0,0.45);
        padding: 0 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .news-item-more{
        width: 100%;
        height: 100%;
        display: block;
        font-size: 30px;
        color: #fff;
        background: #73a9f1;
        line-height: 192px;
        text-align: center;
        padding: 0;
        text-decoration: none;
        &:hover{
          background: #689de1;
        }
      }
    }
  
  }

}
  
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue